<template>
    <section class="onboarding splash">
        <transition>
            <img v-if="tenant" src="/images/illustrations/confetti.svg" alt="Welcome to Skybase!" class="splash__confetti">
        </transition>
        <div class="splash__content">
            <img class="splash__logo" src="/images/skybaseit-beta-inverse.svg" alt="Skybase Logo">
            <template v-if="tenant">
                <h1 class="splash__title">All ready to go!</h1>
                <a :href="tenant.url" class="splash__button button button--yellow button--large">Launch {{ tenant.display_name }}</a>
            </template>
            <template v-else>
                <h1 class="splash__title">
                    Creating your shiny new account
                    <div class="splash__dots">
                        <i class="splash__dot" />
                        <i class="splash__dot" />
                        <i class="splash__dot" />
                    </div>
                </h1>
            </template>
        </div>
    </section>
</template>
<script>
export default {
    data () {
        return {
            tenant: false
        }
    },

    mounted () {
        this.$parent.form.post('/api/create').then((tenant) => {
            this.tenant = tenant
        })
    }
}
</script>
